import React from "react";
import { Link } from "@/components/common/Link";
import { Term } from "@/components/knowledge/Term";
import { RelatedLinks } from "@/components/knowledge/RelatedLinks";
import { BookMarked, ArrowRight } from "lucide-react";
export function FinalReferenceSection() {
  const masterLinks = [{
    to: "/PhilosophyAsInvestigationPage",
    label: "Philosophy as Investigation",
    why: "Begin by mastering conceptual analysis, thought experiments, and fundamental philosophical branches."
  }, {
    to: "/LogicLaboratoryPage",
    label: "Logic Laboratory",
    why: "Construct propositional truth tables and master the mechanics of valid deductive entailment."
  }, {
    to: "/CriticalThinkingPage",
    label: "Critical Thinking Workshop",
    why: "Dissect real-world claims into explicit premises, evaluate hidden assumptions, and practice steelmanning."
  }, {
    to: "/FallacyLibraryPage",
    label: "Fallacy Library",
    why: "Explore specimen cards diagnosing structural, informal, and probabilistic missteps."
  }, {
    to: "/KnowledgeLaboratoryPage",
    label: "Knowledge Laboratory",
    why: "Examine theories of justification, analyze Gettier challenges, and test epistemic virtues."
  }, {
    to: "/SimulationTheoryPage",
    label: "Simulation Theory Lab",
    why: "Investigate computational cosmology, the observer problem, and the limits of physical reality."
  }];
  return <section id="reference-hub" className="w-full scroll-mt-24 min-w-0">
      {/* Master Glossary Banner */}
      <div className="ql-glass p-6 sm:p-8 rounded-2xl border border-border flex flex-col md:flex-row md:items-center justify-between gap-6 mb-8 min-w-0">
        <div className="space-y-2 max-w-2xl min-w-0 flex-1">
          <div className="flex items-center gap-2 min-w-0 flex-wrap">
            <BookMarked className="w-5 h-5 text-primary shrink-0" />
            <span className="ql-eyebrow break-words">MASTER TERMINOLOGY &amp; CITATIONS</span>
          </div>

          <h3 className="font-serif text-xl sm:text-2xl font-bold text-foreground break-words">
            Glossary &amp; References Archive
          </h3>

          <p className="font-sans text-sm text-muted-foreground leading-relaxed break-words min-w-0">
            Unpack over 80 foundational terms spanning <Term id="truth">truth</Term>, <Term id="belief">belief</Term>, <Term id="justification">justification</Term>, <Term id="deduction">deductive validity</Term>, and <Term id="fallibilism">fallibilism</Term>, complete with citations to seminal literature.
          </p>
        </div>

        <div className="shrink-0 max-w-full">
          <Link to="/GlossaryAndReferencesPage" className="ql-neon-button inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full text-sm font-serif font-bold uppercase tracking-wider min-h-[44px] max-w-full text-center">
            <span className="break-words">Open Master Glossary</span>
            <ArrowRight className="w-4 h-4 shrink-0" />
          </Link>
        </div>
      </div>

      {/* Comprehensive Navigation Links */}
      <RelatedLinks title="Architecture of Knowledge Curriculum Matrix" items={masterLinks} />
    </section>;
}